import { createContext, useContext, useReducer  } from 'react'

const ModalContext = createContext()

const useModal = () => {
    const context = useContext(ModalContext)

    if (context === undefined) throw new Error('useModal must be used within a ModalProvider')

    return context
}

const ModalProvider = ({ children }) => {
    const reducer = (state, options) => options

    const [$state, dispatch] = useReducer(reducer, null)

    const open = (options) => {
        options.size = options.size || 'md'

        dispatch(options)
    }

    const configure = (options) => {
        dispatch({ ...$state, ...options })
    }

    const close = () => dispatch(null)

    return (
        <ModalContext.Provider value={{ $state, open, close, configure }}>
            {children}
        </ModalContext.Provider>
    )
}

export { useModal, ModalProvider }